<template>
  <DialogHeader class="p-3 h-[56px] mb-0!">
    <div
      class="w-[70px] h-8 text-white text-[14px] leading-[22px] font-secondary font-medium mr-[17px] rounded-md bg-yellow-500 flex items-center justify-center"
    >
      <Icon name="Lightbulb" class="stroke-white mr-1.5" :size="22" />
      Tips
    </div>
    <div>Share with protection</div>
  </DialogHeader>
  <DialogContent>
    <img
      :src="ManageAccessTipImage"
      class="mb-[19px] border-t border-b border-gray-800/15"
    />
    <div class="px-[30px]">
      <div class="font-primary font-semibold text-[17px] leading-[24px] mb-2.5">
        Invitation and access controls
      </div>
      <div>
        Share with protection and complete control of who can view and download
        your original work and IP through Dacr.
      </div>
    </div>
  </DialogContent>
  <DialogFooter class="px-[30px] pb-[25px] justify-between!">
    <div class="font-secondary text-[13px] leading-[22px] text-gray-400">
      2 of 2
    </div>
    <UiButton primary @click="handleClick"> Okay </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import ManageAccessTipImage from '@/assets/images/manage-access-tip.png'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import {
  GuidanceActionState,
  GuidanceId,
  MeDocument,
  useUpdateGuidanceMutation,
  type MeQuery,
} from '@/shared/graphql/legacy/generated'
import { Icon, UiButton } from '@dacr/ui'

const { close } = useDialog()

const { mutate: updateGuidance } = useUpdateGuidanceMutation()

const handleClick = () => {
  updateGuidance(
    {
      input: {
        id: GuidanceId.OwnersInviteModal,
        action: GuidanceActionState.Completed,
      },
    },
    {
      update(cache, { data }) {
        cache.updateQuery<MeQuery>({ query: MeDocument }, (response) => {
          if (!response || !data?.guidance) return

          return {
            ...response,
            me: {
              ...response.me,
              guidanceStates: data.guidance,
            },
          }
        })
      },
    }
  )
  close()
}
</script>
